import { Product, productVat } from '@Arti-zen/package-backoffice'
import SelectMui from 'components/forms/SelectMui'
import Info from 'components/Info'
import { useState } from 'react'
import { InfoRedStyle, Row, ValidButton } from '../ProductListTable.definitionFields'

type TProps = {
  currentVat: string
  errorMessage: string
  correctProduct: (corrections: Partial<Product>) => void
}

export default function VatProducrErrorTable({ currentVat, correctProduct, errorMessage }: TProps) {
  const [vat, setVat] = useState<number | string>(currentVat)

  const options = [
    { label: <div style={{ color: 'red' }}>{currentVat} %</div>, value: currentVat },
    ...productVat.map((v) => {
      return { value: v, label: `${v}%` }
    }),
    { label: 'Aucun', value: null },
  ]

  const updateVat = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    correctProduct({ vat })
  }

  return (
    <Row style={{ gap: 5 }}>
      <SelectMui onChange={(vat) => setVat(vat)} value={vat} items={options} />
      {vat !== currentVat && <ValidButton onClick={updateVat}>OK</ValidButton>}
      <Info text={errorMessage} style={InfoRedStyle} />
    </Row>
  )
}
